import axios from 'axios'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import getAccessToken from '@/utils/getAccessToken'

export type MutationProps = {
  url: string
  data?: unknown
  method?: 'post' | 'put' | 'delete'
}

const useAuthenticatedMutation = (
  options?: UseMutationOptions<unknown, Error, MutationProps>,
) =>
  useMutation({
    mutationFn: async ({ method = 'post', url, data }: MutationProps) => {
      const token = await getAccessToken()
      if (!token) throw new Error('No access token available')

      const headers = { Authorization: `Bearer ${token}` }
      return method === 'delete'
        ? axios.delete(url, { data, headers })
        : axios[method](url, data, { headers })
    },
    ...options,
  })

export default useAuthenticatedMutation
